import script from "./OpinionsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./OpinionsSection.vue?vue&type=script&setup=true&lang=js"

import "./OpinionsSection.vue?vue&type=style&index=0&id=5f7faeb8&lang=scss"

const __exports__ = script;

export default __exports__